import { useCallback, useEffect, useMemo, useState } from 'react';
import { checkStock, CheckStockResponseDto } from 'src/services/stock';
import { getDimensionsWithGeometry } from 'src/utils/3d.utils';
import styled from 'styled-components';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

type StockRecapProps = {
  step: string;
  pieces: any[];
  customSteles: any[];
  activePieces: any[];
};

export const StockRecap = ({ step, pieces, customSteles, activePieces }: StockRecapProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [stockData, setStockData] = useState<CheckStockResponseDto>();

  const checkStockMutation = useCallback(async () => {
    const stockPieces = pieces.map((piece) => {
      const activePiece = activePieces.find((p) => p.id === piece.id);

      const { x, y, z } = getDimensionsWithGeometry(piece.geometry.attributes.position.array);

      const weight = Math.round((activePiece?.granit?.weight ?? 0) * ((x * y * z) / 100));

      return {
        pieceId: piece.id ?? -1,
        granitId: activePiece.granit?.id ?? '',
        newGeometry: [...piece.geometry.attributes.position.array],
        x,
        y,
        z,
        weight,
      };
    });

    const stockSteles = customSteles.map((stele) => {
      return {
        ...stele,
        granitId: stele.granit?.id ?? '',
      };
    });

    const data = await checkStock({
      stockPieces,
      stockSteles,
    });

    return data;
  }, [pieces, activePieces, customSteles]);

  useEffect(() => {
    checkStockMutation().then((data) => {
      setStockData(data);
    });
  }, [checkStockMutation]);

  if (
    stockData &&
    stockData.stockPieces.length === 0 &&
    stockData.stockSteles.length === 0 &&
    !stockData.assemblyStock
  )
    return null;

  return (
    <Container
      style={{
        width: step === 'QUOTE' ? '55vw' : '65vw',
      }}
    >
      <button
        type="button"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          backgroundColor: '#BC9B68',
          padding: '10px',
          borderRadius: '999px',
          pointerEvents: 'auto',
          border: 'none',
          borderBottomLeftRadius: isOpen ? '0px' : '999px',
          borderBottomRightRadius: isOpen ? '0px' : '999px',
        }}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setIsOpen(!isOpen);
          }
        }}
      >
        <Inventory2OutlinedIcon style={{ color: '#ffffff', fontSize: '20px' }} />
      </button>

      {isOpen && (
        <div
          style={{
            backgroundColor: '#BC9B68',
            padding: '10px',
            paddingTop: '0px',
            paddingBottom: '0px',
            borderRadius: '12px',
            borderTopRightRadius: '0px',
          }}
        >
          {stockData?.assemblyStock ? (
            <p style={{ color: '#ffffff', fontSize: '12px' }}>Assemblage en stock</p>
          ) : (
            <>
              <p style={{ color: '#ffffff', fontSize: '12px' }}>Stock:</p>
              {stockData?.stockPieces.map((stockPiece) => {
                const piece = pieces.find((p) => p.id === stockPiece.pieceId);
                const activePiece = activePieces.find((p) => p.id === piece?.id);

                if (!piece) return null;

                return (
                  <div
                    key={stockPiece.pieceId}
                    style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
                  >
                    <p style={{ color: '#ffffff', fontSize: '12px' }}>
                      {activePiece?.name} - {activePiece?.granit?.name}
                    </p>
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </Container>
  );
};

const Container = styled('div')({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
  height: '100%',
  padding: '20px',
  pointerEvents: 'none',
  bottom: 0,
  left: 0,
  zIndex: 120,
});
